// BrimLight/client/ui/SeriesEditor.js
import { ComponentBase } from "../core/ComponentBase.js";

export class SeriesEditor extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataCrud = null;
    }

    async initialize() {
        this.dataCrud = await this.createManagedComponent("DataCrud", null, {
            instanceId: `${this.config.instanceId}-crud`,
            rpcClass: "SeriesRpc",
            schemaPath: "collections/series",
            title: "My Series Library",
            height: "auto",
            viewConfig: {
                mode: 'grid',
                fields: [
                    { name: 'name', label: 'Series Name' },
                    { name: 'description', label: 'Description' },
                    { name: 'genre', label: 'Genre' },
                    { name: 'videoStyle', label: 'Video Style', render: (val) => val ? val.replace(/_/g, ' ') : 'N/A' },
                ],
            },
            formConfig: {
                fields: {
                    name: { type: 'text', label: 'Series Name', required: true },
                    description: { type: 'textarea', label: 'Description', rows: 2 },
                    genre: { 
                        type: 'select', 
                        label: 'Genre',
                        options: [
                            { value: 'sci-fi', label: 'Sci-Fi' }, { value: 'fantasy', label: 'Fantasy' }, 
                            { value: 'mystery', label: 'Mystery' }, { value: 'thriller', label: 'Thriller' },
                            { value: 'comedy', label: 'Comedy' }, { value: 'drama', label: 'Drama' },
                            { value: 'romance', label: 'Romance' }, { value: 'horror', label: 'Horror' },
                            { value: 'adventure', label: 'Adventure' }, { value: 'documentary', label: 'Documentary' },
                            { value: 'educational', label: 'Educational' }
                        ]
                    },
                    videoStyle: {
                        type: 'select',
                        label: 'Default Video Style',
                        options: [
                            { value: 'cinematic_realistic', label: 'Cinematic Realistic' }, { value: 'pixar_animation', label: 'Pixar Animation' },
                            { value: 'ghibli_style', label: 'Ghibli Style' }, { value: 'anime_90s', label: '90s Anime' },
                            { value: 'claymation', label: 'Claymation' }, { value: 'stop_motion', label: 'Stop Motion' },
                            { value: 'watercolor_painting', label: 'Watercolor Painting' }, { value: 'oil_painting', label: 'Oil Painting' },
                            { value: 'charcoal_sketch', label: 'Charcoal Sketch' }, { value: 'pencil_drawing', label: 'Pencil Drawing' },
                            { value: 'comic_book', label: 'Comic Book' }, { value: 'graphic_novel', label: 'Graphic Novel' },
                            { value: 'low_poly_3d', label: 'Low Poly 3D' }, { value: 'vaporwave', label: 'Vaporwave' },
                            { value: 'cyberpunk', label: 'Cyberpunk' }, { value: 'steampunk', label: 'Steampunk' },
                            { value: 'fantasy_art', label: 'Fantasy Art' }, { value: 'sci_fi_concept_art', label: 'Sci-Fi Concept Art' },
                            { value: 'vintage_film', label: 'Vintage Film' }, { value: 'noir_film', label: 'Noir Film' },
                            { value: 'documentary', label: 'Documentary' }, { value: 'isometric', label: 'Isometric' }
                        ]
                    },
                    defaultNarratorVoice: { type: 'VoiceSelector', label: 'Default Narrator Voice', component: "VoiceSelector" },
                    // --- START OF REFACTOR ---
                    defaultCharacterIds: { 
                        type: 'TagInput', 
                        label: 'Default Characters',
                        component: 'TagInput',
                        optionsSourceRpc: 'CharacterRpc.getFieldValues',
                        placeholder: 'Select default characters...'
                    },
                    defaultEnvironmentIds: { 
                        type: 'TagInput', 
                        label: 'Default Environments',
                        component: 'TagInput',
                        optionsSourceRpc: 'EnvironmentRpc.getFieldValues',
                        placeholder: 'Select default environments...'
                    },
                    defaultPropIds: { 
                        type: 'TagInput', 
                        label: 'Default Props',
                        component: 'TagInput',
                        optionsSourceRpc: 'PropRpc.getFieldValues',
                        placeholder: 'Select default props...'
                    },
                    // --- END OF REFACTOR ---
                    tags: { type: 'TagInput', label: 'Tags', creatable: true, placeholder: "e.g., kids, space, tutorial", component: 'TagInput' },
                },
                sections: [
                    { title: "Core Details", fields: ["name", "description", "tags"] },
                    { title: "Default Settings", fields: ["genre", "videoStyle", "defaultNarratorVoice"] },
                    { title: "Default Assets", fields: ["defaultCharacterIds", "defaultEnvironmentIds", "defaultPropIds"] }
                ]
            },
            dataConfig: {
                autoLoad: false
            }
        });
        await super.initialize();
    }


    async initAfterLogin() {
        if (this.dataCrud) {
            await this.dataCrud.refreshData();
        }
    }

    async render() {
        return this.dataCrud.render();
    }
}